import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {getDefaultHttpHeaders} from '../utils/http-headers.utils';
import {SubscriptionStatus} from '@models/subscription.interface';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  private readonly BASE_URL = environment.apiUrl + '/stripe';

  constructor(private http: HttpClient) {}

  checkSubscription(): Observable<SubscriptionStatus> {
    return this.http.get<SubscriptionStatus>(`${this.BASE_URL}/subscription`, {
      headers: getDefaultHttpHeaders().headers,
    });
  }
}
